import { UserCircleIcon, LogIn } from "lucide-react";
import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import "./style.css";
import IdocImg from '../Assests/kioskImage/AIDOC_img.png';
import p1 from '../Assests/kioskImage/P1.png';
import p2 from '../Assests/kioskImage/P2.png';
import p3 from '../Assests/kioskImage/P3.png';
import p4 from '../Assests/kioskImage/P4.png';
import p5 from '../Assests/kioskImage/P5.png';
import p6 from '../Assests/kioskImage/P6.png';
import d1 from '../Assests/kioskImage/D1.png';
import d2 from '../Assests/kioskImage/D2.png';
import d3 from '../Assests/kioskImage/D3.png';
import d4 from '../Assests/kioskImage/D4.png';
import d5 from '../Assests/kioskImage/D5.png';
import d6 from '../Assests/kioskImage/D6.png';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const patientFeatures = [
    {
        id: 1,
        icon: p1,
        title: "Expert Health Guidance",
        subtitle: "Teleconsultation",
    },
    {
        id: 2,
        icon: p2,
        title: "Your Path to Better Eating",
        subtitle: "Diet Plans",
    },
    {
        id: 3,
        icon: p3,
        title: "Balanced Meals, Better You",
        subtitle: "Weekly Recipes Plans",
    },
    {
        id: 4,
        icon: p4,
        title: "A Smarter Path to Wellness",
        subtitle: "Lifestyle Practices",
    },
    {
        id: 5,
        icon: p5,
        title: "Herbal Healing, Holistic Living",
        subtitle: "Herbal Products",
    },
    {
        id: 6,
        icon: p6,
        title: "Track, Improve, Elevate",
        subtitle: "Health Goals Tracking",
    },
];

const doctorFeatures = [
    {
        id: 1,
        title: "Digital case-sheet for easy access of patient records",
        icon: d1,
    },
    {
        id: 2,
        title: "Significant (2, 3 fold) reduction of consulting time",
        icon: d2,
    },
    {
        id: 3,
        title: "Explainable AI based quantitative Prakriti & Vikriti evalution",
        icon: d3,
    },
    {
        id: 4,
        title: "Remote patient assessment through tele-consultation",
        icon: d4,
    },
    {
        id: 5,
        title: "AI recommendations engine for personalized therapeutics",
        icon: d5,
    },
    {
        id: 6,
        title: "Quantitative tracking of health outcomes",
        icon: d6,
    },
];

const AidocRegistration = () => {
    const [userType, setUserType] = useState('doctor');
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [formData, setFormData] = useState({ name: "", email: "" });
    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    const handleUserTypeChange = (type) => {
        if (type !== userType) {
            setIsTransitioning(true);
            setTimeout(() => {
                setUserType(type);
                setIsTransitioning(false);
            }, 300);
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        setSuccess("");
        setLoading(true);
    
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required.";
        if (!formData.email) newErrors.email = "Email is required.";
    
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setLoading(false);
            return;
        }
    
        try {
            const response = await axios.post("https://f40aygafqj.execute-api.ap-south-1.amazonaws.com/dev/AidocRegister", formData);
    
            if (response.status === 201) {
                setSuccess("Successfully registered!");
                setFormData({ name: "", email: "" });
                handleOpen();
                toast.success("Successfully registered!"); 
            }
    
        } catch (err) {
            const errorMessage = err.response?.data?.error || "Something went wrong. Try submitting again.";
            setErrors({ server: errorMessage });
            toast.error(` ${errorMessage}`); 
            console.error("Registration error:", err);
        } finally {
            setLoading(false);
        }
    };
    const features = userType === 'doctor' ? doctorFeatures : patientFeatures;


    return (
        <main className="main-container">
            <div className="content-wrapper">
                
                <section className="left-section">
                    <div className="enquiry-button">
                        <a href="#enquiry-part">
                        <button className="query-info-item-button p-1" >
                            Enquire Us
                        </button>
                        </a>
                    </div>
                    <div className="app-illustration">
                        <img
                            className="app-interface"
                            alt="AIDOC App Interface"
                            src={IdocImg}
                        />
                    </div>

                    <div className="user-type-toggle">
                        <button
                            className={`toggle-button ${userType === 'doctor' ? 'active' : ''}`}
                            onClick={() => handleUserTypeChange('doctor')}
                        >
                            Doctor
                        </button>
                        <button
                            className={`toggle-button ${userType === 'patient' ? 'active' : ''}`}
                            onClick={() => handleUserTypeChange('patient')}
                        >
                            Patient
                        </button>
                    </div>

                    <div className="features-section mb-8">
                        <h2 className="features-title">Key Features</h2>
                        <div className={`features-grid ${isTransitioning ? 'transitioning' : ''}`}>
                        {features.map((feature) => (
                            <div key={feature.id} className="feature-item">
                                <div className="feature-icon">
                                    <img src={feature.icon} alt={feature.title} />
                                </div>
                                <div className="feature-content">
                                    {feature.subtitle && (
                                            <span className="feature-subtitle">{feature.subtitle}</span>
                                        )}
                                    <span className={`feature-title ${userType === 'patient' ? 'patient-title' : ''}`}>
                                        {feature.title}
                                    </span>
                                    
                                </div>
                            </div>
                        ))}
                        </div>
                    </div>
                </section>

                <section className="right-section">
                    <div className="banner">
                        <p>
                            First of its kind Digital AI assist and Decision Support System
                            for Doctors &amp; Patients
                        </p>
                    </div>

                    <form className="enquiry-form" id="enquiry-part" onSubmit={handleSubmit}>
                        <h2>For Enquiry</h2>
                        <div className="form-fields">
                            <div className="input-group">
                                <div className="input-group-content">
                                    <UserCircleIcon />
                                    <input
                                        type="text"
                                        placeholder="Enter Name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="input-group">
                                <div className="input-group-content">
                                    <LogIn />
                                    <input
                                        type="email"
                                        placeholder="Enter mail id"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </div>
                                </div>
                            </div>
                        <button type="submit" className="submit-button">
                            {loading ? "Submitting..." : "Submit enquiry"}
                        </button>
                        {/* {errors.name && <p className="error">{errors.name}</p>}
                        {errors.email && <p className="error">{errors.email}</p>}
                        {errors.server && <p className="error">{errors.server}</p>}
                        {success && <p className="success">{success}</p>} */}
                    </form>
                </section>
            </div>
        </main>
    );
};

export default AidocRegistration;